import { BufferGeometry, Mesh, MeshBasicMaterial, ShapeGeometry } from "three";
import { Font } from "opentype.js";
import { mergeGeometries } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader.js";

const loader = new SVGLoader();

/**
 * Converts a string into a Mesh object
 * @param relativeScale scale relative to targetHeight
 * @returns the Mesh of the string
 */
export function makeText(
  text: string = "?",
  material: MeshBasicMaterial,
  font: Font
): Mesh | undefined {
  const geometries: BufferGeometry[] = [];

  const path = font.getPath(text, 0, 0, 60);
  const svg = path.toSVG(2);

  const data = loader.parse(svg);
  const paths = data.paths;

  for (let i = 0; i < paths.length; i++) {
    const path = paths[i];

    const shapes = SVGLoader.createShapes(path);

    for (let j = 0; j < shapes.length; j++) {
      const shape = shapes[j];
      const geometry = new ShapeGeometry(shape);
      geometries.push(geometry);
    }
  }

  const merged = mergeGeometries(geometries);
  if (merged) {
    return new Mesh(merged, material);
  } else {
    console.error("issue merging nameplate geometry");
    return undefined;
  }
}
